import {createSelector} from "reselect"
import {connect} from "react-redux"
import {QuickLinkProps} from "../QuickLink"
import {State} from "../../ducks"
import {SupportedRegionTypes, SupportedRegionSubTypes} from "../../models/regions"

const quickLinksSelector = createSelector(
    (state: State) => state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks),
    (state: State) => state.request.siteUrl,
    (state: State) => state.request.cleanSiteUrl,
    (state: State) => state.settings.isTpSuperLite,
    (regions, siteUrl, cleanSiteUrl, isTpSuperLite) =>
        regions?.elements
            .filter(link => link.type === SupportedRegionSubTypes.Link)
            .map(({text, url, accessibilityText, icon}) => {
                return {
                    text,
                    url: `${isTpSuperLite ? cleanSiteUrl : siteUrl}${url}`,
                    accessibilityText: accessibilityText ?? "",
                    icon,
                } as QuickLinkProps
            }),
)

export const mapStateToProps = (state: State) => {
    const {
        request: {url},
        settings: {enableContentBanner, isCountrySelectorInGlobalAppBar, xxlBreakpointEnabled},
    } = state
    const quickLinks = quickLinksSelector(state)

    const MessageBannerControls: any = state.data?.regions.find(
        region => region.type === SupportedRegionTypes.MessageBanner,
    )
    const quickLinkObject = state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks)

    const trimmedUrl = (url && (url[0] === "/" ? url.substring(1) : url)) || ""
    const isContentBannerExcluded =
        (new URLSearchParams(trimmedUrl).get("excludeContentBanner")?.toLocaleLowerCase() || "") === "true"

    return {
        quickLinks,
        enableContentBanner,
        isContentBannerExcluded,
        templating: state.template,
        showMessageBanner: MessageBannerControls?.enabled,
        messageBannerBackgroundColor: quickLinkObject?.style?.backgroundColour || "",
        isCountrySelectorInGlobalAppBar,
        xxlBreakpointEnabled,
    }
}

export default connect(mapStateToProps)
